import { css, StyleSheet } from 'aphrodite'
import PropTypes from 'prop-types'
import { COLOR_GREEN__DARK, COLOR_GREEN__LIGHT } from '../../lib/colors'
import { MEDIA_MIN_SM } from '../../lib/breakpoints'

const UIProgressCircle = ({
  children,
  percent,
  width = 150,
  showPercent = true,
  dynamicStyle,
}) => {
  return (
    <div className={css(styles.container, dynamicStyle)}>
      {showPercent && `${percent}%`}
      {children && children}
      <svg
        width={width}
        height={width} //height proportionnal with width
        viewBox="0 0 150 150"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={css(styles.circle)}
      >
        <circle
          stroke={COLOR_GREEN__LIGHT}
          strokeWidth={10}
          cx="75"
          cy="75"
          r="70"
        />
        <circle
          transform="rotate(-90 75 75)"
          cx="75"
          cy="75"
          r="70"
          stroke={COLOR_GREEN__DARK}
          strokeWidth="10"
          strokeDasharray={`${(440 * percent) / 100}, 440`}
          strokeLinecap="round"
        />
      </svg>
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    fontSize: 24,
    fontWeight: 700,
    color: COLOR_GREEN__DARK,
    [MEDIA_MIN_SM]: {
      padding: '1.5em',
    },
  },
  circle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
})

UIProgressCircle.propTypes = {
  percent: PropTypes.number,
  width: PropTypes.string,
  showPercent: PropTypes.bool,
  children: PropTypes.node,
  dynamicStyle: PropTypes.node,
}

export default UIProgressCircle
